import palette from "../palette";
import typography from "../typography";

export default {
	body: { color: palette.black},
	root: {
		//...typography.body1,
		//color: "#00FF00",
		borderBottom: `1px solid ${palette.divider}`,
	},
};
